import { Pipe, PipeTransform } from '@angular/core';
import { selectTabloPrices } from '@ui/products/shopping-cart-back/actions/selector';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { TabloInBasket } from '@ui/products/shopping-cart-back/actions/standalone';
import { Observable } from 'rxjs';
import { PriceConfig } from '@ui/orders/graphql';

@Pipe({
    name: 'tabloPrice',
    standalone: false
})
export class TabloPricePipe implements PipeTransform {
  constructor(private store: Store) {}

  transform(
    value: TabloInBasket,
    ...args: unknown[]
  ): Observable<PriceConfig[]> {
    return this.store.select(selectTabloPrices).pipe(
      // map(v=>v.find(vv=>vv.id===value.tabloId)?.price)
      map((prices) =>
        prices
          .find((price) => price.tabloForDisplayId === value.tabloForDisplayId)
          ?.price.map((v) => ({
            code: v.code,
            price: v.price * value.count,
          })),
      ),
    );
  }
}
